<!--列表查看视图-->
<template>
  <div class="details-view project-detail">
    <div class="main-content">
      <div v-show="topBtGroupVisdeld" class="app-main-inner-row operations" style="padding-left: 0px;">
        <div class="triggers">
          <div>
            <el-button type="primary" no="1" @click="toBackList">{{ $t('ProjectManage.Cancel') }}</el-button>
            <el-button type="primary" :disabled="canSave" no="2" @click="doSave">{{ $t('ProjectManage.Save') }}</el-button>
            <el-button type="primary" :disabled="canSave" no="3" @click="asyncCharge">{{ $t('ProjectManage.SynchronizeFees') }}</el-button>
          </div>
        </div>
      </div>
      <div v-show="botBtGroupVisdeld" class="app-main-inner-row operations" style="padding-left: 0px;">
        <div class="triggers">
          <div>
            <el-button type="success" no="4" @click="toCancel">{{ $t('common.btn.back') }}</el-button>
            <el-button type="primary" no="5" @click="toEdit">{{ $t('common.btn.edit') }}</el-button>
            <el-button v-permission="['button_ProjectModule_delete']" type="danger" no="6" @click="toBatchDelete">{{ $t('common.btn.delete') }}</el-button>
            <el-button type="success" no="7" @click="toAdd">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" no="8" @click="toExportToExcel">{{ $t('common.btn.exportExcel') }}</el-button>
            <el-button type="primary" :disabled="yuhaiApiIsEdit" no="9" @click="toCloseProject">{{ $t('Project.CloseProject') }}</el-button>
            <el-button type="primary" :disabled="yuhaiApiIsEdit" no="10" @click="toOpenProject">{{ $t('Project.RebuildProject') }}</el-button>
          </div>
        </div>
      </div>
      <div
        class="tabs-container"
        style="margin-top: 5px"
      >
        <el-tabs v-model="activeTabName" type="card" style="width:100%">
          <el-tab-pane :label="$t('ProjectManage.BasicInformation')" name="basic">
            <basic ref="basicTab" />
          </el-tab-pane>
          <el-tab-pane v-if="notNew" :label="$t('ProjectManage.FileHistory')" name="fileHistory">
            <file-history ref="fileHistoryTab" />
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import basicTab from './basicTab'
import fileHistoryTab from './fileHistoryTab'
import { newProject, update, batchCloseProject, batchOpenProject, batchDeleteProject, asyncCharge
} from '@/api/projectManage/project'
import { cacheName, cache } from '@/utils/cacheManager'
import { getDepIdAndOffIdByUserOrDep
} from '@/api/user'

export default {
  name: 'ProjectDetail',
  components: {
    cargoAdvanceSelect,
    fileHistoryTab,
    basic: basicTab,
    fileHistory: fileHistoryTab
  },
  props: {
    viewSource: { type: String, required: true },
    rowUuid: { type: String, required: false },
    op: { type: Number, required: true }
  },
  data() {
    return {
      defaultDepartment: {
        depId: 0,
        userId: 0
      },
      uuids: [],
      uuid: '',
      loading: false,
      bookingAction: '',
      activeTabName: 'basic',
      notNew: true, // 新增文件历史不可见
      canSave: true, // 是否可编辑
      topBtGroupVisdeld: false, // 新增按钮组可见
      botBtGroupVisdeld: true, // 查看按钮组可见
      copyForm: {
        uuid: '',
        projectNo: '',
        projectName: '',
        projectStatus: 0,
        partener: 0,
        dateStart: '',
        dateEnd: '',
        settleCurrency: 0,
        expectIncome: 0.00,
        realIncome: 0.00,
        projectManager: 0,
        expectCost: 0.00,
        realCost: 0.00,
        projectDepartment: 0,
        expectExpense: 0.00,
        realExpense: 0.00,
        projectOffice: 0,
        receiveStatus: 0,
        expectProfitTate: 0,
        realProfitTate: 0.00,
        payStatus: 0,
        remarks: ''
      },
      yuhaiApiIsEdit: false
    }
  },
  watch: {},
  beforeMount() {
    this.showDetail(this.rowUuid, this.op)
  },
  methods: {
    async showDetail(uuid, oprationType) {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      if (oprationType === undefined) {
        this.topBtGroupVisdeld = true
        this.botBtGroupVisdeld = false
        this.$refs.basicTab.isEdit = false
      }
      this.yuhaiApiIsEdit = (Number(cache.config.get('yuhaiApiIsEdit')) === 1) // 越海接口是否可编辑
      // 查看
      if (oprationType === 1) {
        this.notNew = true
        this.uuid = uuid
        if (this.uuids.length === 0) {
          this.uuids.push(uuid)
        }
        this.$refs.fileHistoryTab.preloadBasicData(uuid)
        this.topBtGroupVisdeld = false
        this.botBtGroupVisdeld = true
        this.canSave = true
        this.$refs.basicTab.isEdit = true
        this.$refs.basicTab.getDetail(uuid)
      }
      // 编辑
      if (oprationType === 2) {
        this.uuid = uuid
        if (this.uuids.length === 0) {
          this.uuids.push(uuid)
        }
        this.$refs.fileHistoryTab.preloadBasicData(uuid)
        this.notNew = true
        this.topBtGroupVisdeld = true
        this.botBtGroupVisdeld = false
        this.canSave = false
        this.$refs.basicTab.isEdit = false
        this.$refs.basicTab.getDetail(uuid)
      }
      // 新增
      if (oprationType === 3) {
        this.notNew = false
        this.topBtGroupVisdeld = true
        this.botBtGroupVisdeld = false
        this.canSave = false
        this.$refs.basicTab.isEdit = false
        this.$refs.basicTab.otherTotal.expectTotalCost = 0
        this.$refs.basicTab.otherTotal.realTotalCost = 0
        this.$refs.basicTab.form = { ...this.$refs.basicTab.initForm } // 初始化表格
        // 处理当前操作人，部门，公司
        // this.$refs.basicTab.form.projectManager = cache.user.userId
        // if (cache.user.defaultDepId === undefined || cache.user.defaultDepId === 0 || cache.user.defaultOfficeId === undefined || cache.user.defaultOfficeId === 0) {
        //   // 没有默认部门，获取当前部门根据用户id
        //   this.defaultDepartment.depId = cache.user.defaultDepId
        //   getDepIdAndOffIdByUserOrDep(this.defaultDepartment).then(res => {
        //     if (res.data === '' || res.data === null) {
        //       this.$refs.basicTab.form.projectDepartment = 0
        //       this.$refs.basicTab.form.projectOffice = 0
        //     } else {
        //       this.$refs.basicTab.form.projectDepartment = res.data.departmentId
        //       this.$refs.basicTab.form.projectOffice = res.data.officeId
        //     }
        //   })
        // } else {
        //   this.form.projectDepartment = cache.user.defaultDepId
        //   this.form.projectOffice = cache.user.defaultOfficeId
        // }
      }
    },
    // 取消
    toBackList() {
      if (this.notNew) { // 编辑状态
        this.$refs.fileHistoryTab.preloadBasicData(this.uuid)
        this.notNew = true
        this.topBtGroupVisdeld = false
        this.botBtGroupVisdeld = true
        this.canSave = true
        this.$refs.basicTab.isEdit = true
        this.$refs.basicTab.getDetail(this.uuid)
      } else {
        this.$refs.basicTab.form.projectManager = 0
        this.$emit('backList', this.viewSource)
      }
    },
    toCancel() {
      this.$refs.basicTab.form.projectManager = 0
      this.$emit('backList', this.viewSource)
    },
    doSave() {
      const data = this.$refs.basicTab.form
      const self = this
      if (!data.projectName.trim()) {
        self.$message.warning(this.$t('ProjectManage.ProjectNameCannotBeEmpty'))
        return
      }

      if (!data.partener) {
        self.$message.warning(this.$t('ProjectManage.CustomerNameCannotBeEmpty'))
        return
      }

      if (!data.dateStart || !data.dateEnd) {
        self.$message.warning(this.$t('ProjectManage.ProjectCycleCannotBeEmpty'))
        return
      } else {
        if (new Date(data.dateStart) > new Date(data.dateEnd)) {
          self.$message.warning(this.$t('ProjectManage.EndBeEarlierThanDate'))
          return
        }
      }

      if (!data.settleCurrency) {
        self.$message.warning(this.$t('ProjectManage.AccountingCurrencyCannotBeEmpty'))
        return
      }

      // if (!data.expectIncome || data.expectIncome === 0) {
      //   self.$message.warning('预计收入不能为空！')
      //   return
      // }

      if (!data.projectManager) {
        self.$message.warning(this.$t('ProjectManage.ProjectManagerCannotBeEmpty'))
        return
      }

      // if (!data.expectCost || data.expectCost === 0) {
      //   self.$message.warning('预估成本不能为空！')
      //   return
      // }

      if (!data.projectDepartment) {
        self.$message.warning(this.$t('ProjectManage.ProjectDepartmentCannotBeEmpty'))
        return
      }

      // if (!data.expectExpense || data.expectExpense === 0) {
      //   self.$message.warning('预估费用不能为空！')
      //   return
      // }

      if (!data.projectOffice) {
        self.$message.warning(this.$t('ProjectManage.ProjectCompanyCannotBeEmpty'))
        return
      }
      if (this.$refs.basicTab.form.projectStatus === 0) {
        data.projectStatus = 1
      }
      if (data.uuid) {
        update(data).then(res => {
          this.$message.success(this.$t('ProjectManage.SaveSuccessfully'))
          this.$emit('backList', this.viewSource)
        })
      } else {
        data.branchId = this.$store.getters.currentOfficeId
        newProject(data).then(res => {
          this.$message.success(this.$t('ProjectManage.SaveSuccessfully'))
          this.$emit('backList', this.viewSource)
        })
      }
    },
    // 同步费用
    asyncCharge() {
      const data = this.$refs.basicTab.form
      if (data.uuid) {
        const request = { 'uuid': data.uuid }
        asyncCharge(request).then(res => {
          // eslint-disable-next-line no-unused-vars
          const resData = res.data
          console.log(resData)
          this.$refs.basicTab.asyncCharge(resData.data)
        })
      }
    },
    // 编辑
    toEdit() {
      const self = this
      if (this.$refs.basicTab.form.projectStatus === 2) {
        self.$message.warning(this.$refs.basicTab.form.projectNo + this.$t('ProjectManage.TheStatusCannotBeEdited'))
        return
      }
      this.notNew = true
      this.topBtGroupVisdeld = true
      this.botBtGroupVisdeld = false
      this.canSave = false
      this.$refs.basicTab.isEdit = false
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 删除
    toBatchDelete() {
      const self = this
      if (this.$refs.basicTab.form.projectStatus === 2) {
        self.$message.warning(this.$refs.basicTab.form.projectNo + '当前项目状态无法进行删除操作')
        return
      }
      this.$confirm(this.$t('ProjectManage.PleaseToDeleteTheNumber') + this.$refs.basicTab.form.projectNo + '的项目', this.$t('ProjectManage.Prompt'), {
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchDeleteProject(this.uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.DeletedSuccessfully'))
          this.$emit('backList', this.viewSource)
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.DeletionCancelled'))
      })
    },
    // 新增
    toAdd() {
      // 处理当前操作人，部门，公司
      this.notNew = false
      this.topBtGroupVisdeld = true
      this.botBtGroupVisdeld = false
      this.canSave = false
      this.$refs.basicTab.isEdit = false
      this.$refs.basicTab.otherTotal.expectTotalCost = 0
      this.$refs.basicTab.otherTotal.realTotalCost = 0
      this.$refs.basicTab.form = { ...this.$refs.basicTab.initForm } // 初始化表格
      // 处理当前操作人，部门，公司
      // this.$refs.basicTab.form.projectManager = cache.user.userId
      // if (cache.user.defaultDepId === undefined || cache.user.defaultDepId === 0 || cache.user.defaultOfficeId === undefined || cache.user.defaultOfficeId === 0) {
      //   // 没有默认部门，获取当前部门根据用户id
      //   this.defaultDepartment.depId = cache.user.defaultDepId
      //   getDepIdAndOffIdByUserOrDep(this.defaultDepartment).then(res => {
      //     if (res.data === '' || res.data === null) {
      //       this.$refs.basicTab.form.projectDepartment = 0
      //       this.$refs.basicTab.form.projectOffice = 0
      //     } else {
      //       this.$refs.basicTab.form.projectDepartment = res.data.departmentId
      //       this.$refs.basicTab.form.projectOffice = res.data.officeId
      //     }
      //   })
      // } else {
      //   this.form.projectDepartment = cache.user.defaultDepId
      //   this.form.projectOffice = cache.user.defaultOfficeId
      // }
    },
    // 导出Excel
    toExportToExcel() {
      this.$parent.toExportToExcel()
    },
    // 关闭项目
    toCloseProject() {
      const self = this
      if (this.$refs.basicTab.form.projectStatus === 2) {
        self.$message.warning(this.$refs.basicTab.form.projectNo + '项目状态已完成')
        return
      }
      this.$confirm(this.$t('ProjectManage.PleaseCanCloseTheNumber') + this.$refs.basicTab.form.projectNo + '的项目', this.$t('ProjectManage.Prompt'), {
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchCloseProject(this.uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.ClosedSuccessfully'))
          this.$refs.fileHistoryTab.preloadBasicData(this.uuid)
          this.topBtGroupVisdeld = false
          this.botBtGroupVisdeld = true
          this.canSave = true
          this.$refs.basicTab.isEdit = true
          this.$refs.basicTab.getDetail(this.uuid)
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.CancelledClosing'))
      })
    },
    // 打开项目
    toOpenProject() {
      const self = this
      if (this.$refs.basicTab.form.projectStatus === 1) {
        self.$message.warning(this.$refs.basicTab.form.projectNo + this.$t('ProjectManage.ProjectStatusInProgress'))
        return
      }
      this.$confirm(this.$t('ProjectManage.PleaseNeedToReopenNumber') + this.$refs.basicTab.form.projectNo + '的项目', this.$t('ProjectManage.Prompt'), {
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchOpenProject(this.uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.OpenedSuccessfully'))
          this.$refs.fileHistoryTab.preloadBasicData(this.uuid)
          this.topBtGroupVisdeld = false
          this.botBtGroupVisdeld = true
          this.canSave = true
          this.$refs.basicTab.isEdit = true
          this.$refs.basicTab.getDetail(this.uuid)
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.CancelledOpening'))
      })
    }
  }
}
</script>
